import PageSection from "../Layout/PageSection";
import { useContext, useState } from "react";
import Context from "../../../context";
import { useFormik } from "formik";
import Button from "../Input/Button";

import axios from "axios";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { API_URL } from "../../data/constants";

function getSixtyDays(date) {
  var res = new Date(date);
  res.setDate(res.getDate() + 60);
  return res;
}

export default function DownloadPageSection({ accounts }) {
  const { contextState, setContextState } = useContext(Context);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [downloadType, setDownloadType] = useState(0); //xls, csv, zip
  const [dataType, setDataType] = useState(0); //detailed, summary
  const [dataRange, setDataRange] = useState(0); //all, current, range
  const [summaryType, setSummaryType] = useState("bill"); //bill, payment
  const [submitting, setSubmitting] = useState(false);

  let account = contextState.currentAccount;
  let userRole = localStorage.getItem("userRole");

  function validate() {
    const errors = {};

    return errors;
  }

  const downloadDataForm = useFormik({
    initialValues: {
      fromDate: null,
      toDate: null,
      fileType: 0, // 0 xls, 1 csv, 2 zip
      dataType: 0, //0 detailed, 1 summary
      summaryDataType: 0, // 0 bill, 1 payment
      lookupType: 0, // 0 all dates, 1 current, 2 range
    },
    validate,
    onSubmit: (values) => {
      setSubmitting(true);
      values.fileType = downloadType;
      values.lookupType = dataRange;
      values.dataType = dataType;
      if (dataRange === 2) {
        values.fromDate = fromDate;
        values.toDate = toDate;
      }

      if (downloadType === 2) setSummaryType("");

      switch(summaryType) {
        case "bill":
          values.summaryDataType = 0;
          break;
        case "payment":
          values.summaryDataType = 1;
          break;
        case "usage":
          values.summaryDataType = 2;
          break;
        default:
          values.summaryDataType = 0;
      }

      let accountsToSend = Array.isArray(accounts)
        ? accounts
            .filter((acct) => acct.isSelected)
            .map((acct) => {
              return {
                customerName: acct.customerName,
                customerId: acct.customerId,
                customerNumber: acct.customerNumber,
                masterCustomerId: null,
              };
            })
        : [
            {
              customerName: account.customerName,
              customerId: account.contract.customerId,
              customerNumber: account.customerNumber,
              masterCustomerId: null,
            },
          ];
      axios
        .post(
          API_URL + "/Data/Download",
          {
            fromDate: values.fromDate,
            toDate: values.toDate,
            accounts: accountsToSend,
            fileType: values.fileType,
            dataType: values.dataType,
            summaryDataType: values.summaryDataType,
            lookupType: values.lookupType,
          },
          {
            headers: {
              Authorization: `${localStorage.getItem("accessToken")}`,
            },
            responseType: "arraybuffer",
          }
        )
        .then((res) => {
          let blob = new Blob([res.data], { type: "" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `FNG_Data_${dayjs().format("MMDDYYYY-HHmmss")}.${
            values.fileType === 0
              ? "xlsx"
              : values.fileType === 1
              ? "csv"
              : "zip"
          }`;
          link.click();
          setSubmitting(false);
        })
        .catch((err) => {
          setSubmitting(false);
          console.error(err);
        });
    },
  });

  return (
    <>
      <form onSubmit={downloadDataForm.handleSubmit}>
        <h1 className="page-header-text">Download Data</h1>
        <div className="row">
          <div className="col">
            <PageSection sectionName="Select Data Type" isForm={true}>
              <ul className="nav mx-n3 d-flex">
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${
                        downloadType === 0 ? " selected" : ""
                      }`}
                      onClick={() => {
                        setDownloadType(0);
                      }}>
                      <div className="radio-input"/>
                      <label className="radio-label">
                        XLS (Microsoft Excel)
                      </label>
                    </div>
                  </div>
                </li>
                { dataType !== 3 && (
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${
                        downloadType === 1 ? " selected" : ""
                      }`}
                      onClick={() => {
                        setDownloadType(1);
                      }}>
                      <div className="radio-input" />
                      <label className="radio-label">
                        CSV (comma-separated values)
                      </label>
                    </div>
                  </div>
                </li>
                )}
              </ul>
              <hr className="mx-0" />
              <ul className="nav mx-n3 d-flex">
                <li className="nav-item d-flex">
                  <div className="nav-link">
                    <div
                      className={`radio${
                        dataType === 0 && dataType !== 2 && dataType !== 3 ? " selected" : ""
                      }`}
                      onClick={() => {
                        setDataType(0);
                        setDownloadType(0);
                      }}>
                      <div className="radio-input" />
                      <label className="radio-label">Detailed Data</label>
                    </div>
                    <small>
                      <br />
                      This includes charges, billing, payments, and usage
                      information.
                    </small>
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${
                        dataType === 1 && dataType !== 2 && dataType !== 3 ? " selected" : ""
                      }`}
                      onClick={() => {
                        setDataType(1);
                        setDownloadType(0);
                        setSummaryType("bill");
                      }}>
                      <>
                        <div className="radio-input" />
                        <label className="radio-label">Summary Data</label>
                      </>
                    </div>
                    <ul className="nav">
                      <li className="nav-item d-flex">
                        <div className="nav-link">
                          <div
                            className={`radio${
                              summaryType === "bill" && dataType === 1
                                ? " selected"
                                : ""
                            }`}
                            onClick={() => {
                              setDataType(1);
                              setSummaryType("bill");
                            }}>
                            <div className="radio-input" />
                            <label className="radio-label">
                              Bill Information
                            </label>
                          </div>
                          <small>
                            <br />
                            Summary of monthly statements for selected date
                            range
                          </small>
                        </div>
                      </li>
                      <li className="nav-item d-flex">
                        <div className="nav-link">
                          <div
                            className={`radio${
                              summaryType === "payment" && dataType === 1
                                ? " selected"
                                : ""
                            }`}
                            onClick={() => {
                              setDataType(1);
                              setSummaryType("payment");
                            }}>
                            <div className="radio-input" />
                            <label className="radio-label">
                              Payment Information
                            </label>
                          </div>
                          <small>
                            <br />
                            Summary of payments received for selected date range
                          </small>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
              <hr className="mx-0" />
              <ul className="nav mx-n3 d-flex">
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${
                        downloadType === 2 ? " selected" : ""
                      }`}
                      onClick={() => {
                        setDataType(2);
                        setDownloadType(2);
                        setSummaryType("bill");
                      }}>
                      <div className="radio-input" />
                      <label className="radio-label">
                        Billing PDF Images as ZIP file
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
              { userRole === "IT-User" && (
              <>
              <hr className="mx-0" />
              <ul className="nav mx-n3 d-flex">
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                        className={`radio${
                          dataType === 3 ? " selected" : ""
                        }`}
                        onClick={() => {
                          setDataType(3);
                          setDownloadType(0);
                          setDataRange(2);
                          setSummaryType("usage");
                        }}>
                      <div className="radio-input" />
                      <label className="radio-label">
                        Daily Usage
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
              </>
              )}
            </PageSection>
          </div>
          <div className="col">
            <PageSection sectionName="Select Data Range" isForm={true}>
              { dataType !== 3 && (
              <p className="select-data-header">
                Select up to 24 months of billing &amp; usage data.
              </p>
              )}
              <ul className="nav mx-n3 d-flex flex-column mb-4">
                { dataType !== 3 && (
                <>
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${dataRange === 0 ? " selected" : ""}`}
                      onClick={() => {
                        setDataRange(0);
                      }}>
                      <div className="radio-input" />
                      <label className="radio-label">All Available Dates</label>
                    </div>
                  </div>
                </li>
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${dataRange === 1 ? " selected" : ""}`}
                      onClick={() => {
                        setDataRange(1);
                      }}>
                      <div className="radio-input" />
                      <label className="radio-label">Current Bill</label>
                    </div>
                  </div>
                </li>
                </>
                )}
                <li className="nav-item">
                  <div className="nav-link">
                    <div
                      className={`radio${dataRange === 2 ? " selected" : ""}`}
                      onClick={() => {
                        setDataRange(2);
                      }}>
                      <div className="radio-input" />
                      <label className="radio-label">Date Range</label>
                    </div>
                  </div>
                </li>
              </ul>
              <div className="row mb-4">
                <div className="col">
                  <label className="form-label">From Date</label>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    maxDate={getSixtyDays(new Date())}
                  />
                </div>
                <div className="col">
                  <label className="form-label">To Date</label>
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    maxDate={getSixtyDays(new Date())}
                  />
                </div>
              </div>
              <div className="row">
                { dataType !== 3 && (
                <p className="page-section-warning data-range-text">
                  The data export is based on the invoice creation date, not the
                  due date. This is done to avoid unintentionally exporting data
                  for usage outside the expected range.
                </p>
                )}
              </div>
            </PageSection>
          </div>
        </div>
        <div className="form-section--button">
          <Button 
            className="btn btn--green btn--bordered"
            type="submit"
            text="Start Download"
            disabled={(dataType === 2 && downloadType === 0 || dataType === 2 && downloadType === 1)}
            submitting={submitting}
          />
        </div>
      </form>
    </>
  );
}
